export default "__VITE_ASSET__BMxWlOGZ__"